import React from 'react';
import S from './input.TextInput.Styled';

export const TextInput = props => <S.Input {...props} />;
